import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import InfoTooltip from '../../../../elements/InfoTooltip'
import MultiCurrency from '../../../../elements/MultiCurrency'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withData from '../../../../elements/Select/withData'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import _, { get, isEmpty, sumBy } from 'lodash'
import { dateVal, moneyInline } from '../../../../modules/Utils'
import React from 'react'
import { Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'

import { compose } from 'recompose'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import BankingModal from '../../../../components/People/Member/Modal/Banking'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import { AddRemittanceContext } from '../../../Purchasing/Remittance/AddRemittance/AddRemittanceCont'

const { TextArea } = Input

const MethodSelect = compose(
  withData({
    data: [
      { key: 'Bank Transfer', value: 'Bank Transfer' },
      { key: 'Credit Card', value: 'Credit Card' },
      { key: 'Contra', value: 'Contra' },
    ],
  }),
  withSort
)(CustomSelect)

function RemittanceForm(props) {
  const { remittance, lines, modalType } = React.useContext(AddRemittanceContext)
  const { paymentRequestList, selection } = props
  const selectedPaymentRequest = selection.map((s) => paymentRequestList.find((p) => _.get(p, '_id') === s))

  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const payor = getFieldValue('from.payor._id') || get(remittance, 'from.payor._id')

  const BankSelect = compose(
    withUrlFetch({
      name: 'banks',
      url: `banks/` + (isEmpty(payor) ? '' : `?owner=${payor}`),
      cache: true,
    }),
    withSpinning,
    withSort
  )(CustomSelect)

  const FileSelectCmp = compose(
    withUrlFetch({
      name: `${remittance._id}_files`,
      url: `files/?folder=${remittance._id}`,
      // forceFetch: true,
    }),
    withSpinning,
    withSort
  )(CustomSelect)

  const payee =
    getFieldValue('to.payee._id') || get(remittance, 'to.payee._id') || get(selectedPaymentRequest, '[0]payee._id')
  const { visible, onShow, onCancel } = useModalShow()
  return (
    <Form>
      <BankingModal bank={get(remittance, 'to.bank')} type={'view'} visible={visible} handleCancel={onCancel} />
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Date">
            {getFieldDecorator('date', {
              initialValue: dateVal(remittance, 'date'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <h3>From</h3>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Company">
            {getFieldDecorator('from.payor._id', {
              initialValue: get(remittance, 'from.payor._id'),
              rules: rules.select,
            })(<OrganisationsSelect />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Bank Account">
            {getFieldDecorator('from.bank._id', {
              initialValue: get(remittance, 'from.bank._id'),
              rules: rules.select,
            })(
              <BankSelect style={{ width: '100%' }} keyAtr={'_id'} valueAtr={'nickname'} placeholder={'Bank Account'} />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Amount">
            {getFieldDecorator('from.amount', {
              initialValue: get(remittance, 'from.amount'),
              rules: rules.input,
            })(<InputNumber type="number" placeholder={'Amount'} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <MultiCurrency
          doc={remittance}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            type: 'remittance',
          }}
        />
      </Row>

      <h3>To</h3>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Vendor">
            <span>{get(remittance, 'to.payee.fn') || get(selectedPaymentRequest, '[0]payee.fn')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Address">
            <span>
              {get(remittance, 'to.payee.address.label') || get(selectedPaymentRequest, '[0]payee.address.label')}
            </span>
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={<strong style={{ fontSize: '16px' }}>Amount</strong>}>
            <strong style={{ fontSize: '16px' }}>
              {moneyInline(
                sumBy(lines, 'allocation') ||
                  get(remittance, 'to.payee.amount') ||
                  get(selectedPaymentRequest, '[0]payee.amount'),
                get(remittance, 'to.currency') || get(selectedPaymentRequest, '[0]currency')
              )}
            </strong>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Currency">
            <span>{get(remittance, 'to.currency') || get(selectedPaymentRequest, '[0]currency')}</span>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <h4>Banking Details</h4>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Bank Account Name">
            <span>{get(remittance, 'to.bank.accname')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Bank Account Number">
            <span>{get(remittance, 'to.bank.number')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Country" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.country')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Bank Account IBAN" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.iban')}</span>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Bank" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.name')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Branch" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.branch')}</span>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="SWIFT Code" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.swift')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Branch Code" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.code')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="BSB Code" {...defaultFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.bsb')}</span>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Address" {...fullWidthFormItemLayout}>
            <span>{get(remittance, 'to.bank.bank.address')}</span>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Bank Advice'} title={'If empty; please upload files in documents tab.'} />}>
            {getFieldDecorator('to.bankAdvice', {
              initialValue: get(remittance, 'to.bankAdvice'),
            })(<FileSelectCmp keyAtr="_id" valueAtr="name" placeholder={'Bank Advice'} />)}
          </Form.Item>
        </Col>
      </Row>

      <h3>Transaction details</h3>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Transaction Ref">
            {getFieldDecorator('transaction.ref', {
              initialValue: get(remittance, 'transaction.ref'),
              rules: rules.input,
            })(<Input />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Transaction ttRef">
            {getFieldDecorator('transaction.ttref', {
              initialValue: get(remittance, 'transaction.ttref'),
            })(<Input />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Method">
            {getFieldDecorator('transaction.method', {
              initialValue: get(remittance, 'transaction.method'),
              rules: rules.select,
            })(<MethodSelect />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Instructions">
            {getFieldDecorator('transaction.instruction', {
              initialValue: get(remittance, 'transaction.instruction'),
            })(<TextArea rows={7} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Payments Details">
            {getFieldDecorator('transaction.paymentDetails', {
              initialValue: get(remittance, 'transaction.paymentDetails'),
            })(<TextArea rows={7} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

RemittanceForm.propTypes = {}
RemittanceForm.defaultProps = { selection: [] }

export default Form.create()(RemittanceForm)
